import type { ValueHandler } from '@broker-as/acquisit-ui-vue/library'

export const handleSignature: ValueHandler = async ({
	component,
	value,
	setProperties
}): Promise<void> => {
	// Point is to avoid invalidations
	
	setProperties(component, {
		modelValue: value
	})
}